import script from "./ConfirmOrder.vue?vue&type=script&lang=ts&setup=true"
export * from "./ConfirmOrder.vue?vue&type=script&lang=ts&setup=true"

import "./ConfirmOrder.vue?vue&type=style&index=0&id=3ed14f74&lang=scss"

const __exports__ = script;

export default __exports__